import { get } from '../index';

export const superAdminGetCompanies = () => {
  return get('/super-admin-panel');
};
